import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ActionTableCell, ExTable, TableBody, TableHead, TableWrapper } from 'components/shared/widget'
import { Tag, TagSearchForm } from 'entities/tag'
import { useDeleteTagApi, useFetchTagsApi } from 'api/tag'
import { tagColumnInfoList, TagTableData } from './tag_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditTagForm, NewTagForm } from './tag_form'
import { useState } from 'react'
import { SearchConditionView } from 'components/shared/search_drawer'

type Props = {
    history: H.History
}

const TagsPage = (props: Props) => {
    const query = useQuery<{ type: string }>()
    const searchForm = useForm<TagSearchForm>({ type: query.type })
    const listApi = useFetchTagsApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const tagDisplaySetting = useDisplaySetting(tagColumnInfoList(searchForm, query.type), 'Tag')
    const deleteApi = useDeleteTagApi()
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedTag, setSelectedTag] = useState<Tag>({})

    useEffect(() => {
        listApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    const handleClickRemoveFilter = (key: keyof TagSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <EditTagForm
                show={showEdit}
                tag={selectedTag}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle="Tags"
                left={
                    <>
                        <NewTagForm onComplete={() => listApi.execute()} type="probe" />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['type']} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <ActionTableCell th></ActionTableCell>
                                <ActionTableCell th></ActionTableCell>
                                <TableHeads displaySetting={tagDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((tag: Tag) => {
                                return (
                                    <tr key={tag.id}>
                                        <ActionTableCell
                                            action={'delete'}
                                            onClick={() => {
                                                globalState.showConfirm('本当に削除しますか？', () => {
                                                    deleteApi.execute(tag.id!)
                                                })
                                            }}
                                        />
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedTag(tag)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <TagTableData tag={tag} displaySetting={tagDisplaySetting} type={query.type} />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(TagsPage)
